import { fileApi } from '../redux/services/file';
import { recordApi } from '../redux/services/record';
import { appDispatch } from '../redux/store-accessors';

// Invalidate tags specific to a single record
export const invalidateRecordSpecificTags = (recordId: string) => {
  appDispatch(
    recordApi.util.invalidateTags([
      { type: 'Record', id: recordId },
      { type: 'LinkedRecord', id: `LIST-${recordId}` },
      { type: 'ReverseLinkedRecord', id: `LIST-${recordId}` },
      { type: 'SummaryLinkedRecord', id: `LIST-${recordId}` },
    ])
  );

  appDispatch(fileApi.util.invalidateTags([{ type: 'File', id: `${recordId}-LIST` }]));
};

// Invalidate general shared tags related to records
export const invalidateSharedTags = () => {
  appDispatch(
    recordApi.util.invalidateTags([
      { type: 'AllFormsRecord', id: 'LIST' },
      { type: 'RecordVersion', id: 'LIST' },
      { type: 'Collaborator', id: 'LIST' },
    ])
  );

  appDispatch(fileApi.util.invalidateTags(['QuestionnaireFile']));
};
